/*
 * HMC knife-in-cart free shipping helper (draft theme).
 * Optional safety net on top of the automatic "free shipping over $1,000" discount.
 * When the theme setting "Knife free-shipping discount code" (hmc_knife_ship_code) is set, the code is
 * added to the cart silently while any line item has product type "Knife" and removed when none does.
 * All calls are background /cart/update.js requests WITHOUT sections, so nothing is re-rendered:
 * the cart drawer is never opened, closed or reloaded by this script.
 * If the setting is blank this file does nothing.
 */
(function () {
  var cfg = window.hmcShip || {};
  var CODE = String(cfg.code || '').trim();
  var TYPE = String(cfg.type || 'Knife').toLowerCase();

  function same(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }
  function jsonFetch(url, init) {
    init = init || {};
    init.headers = Object.assign({ Accept: 'application/json', 'X-HMC-Ship': '1' }, init.headers || {});
    init.cache = 'no-store';
    return window.fetch(url, init).then(function (r) { return r.json(); });
  }
  function getCart() { return jsonFetch('/cart.js'); }
  function hasKnife(cart) {
    return (cart.items || []).some(function (i) { return String(i.product_type || '').toLowerCase() === TYPE; });
  }
  function setCodes(codes) {
    return jsonFetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
  }

  var pending = 0;
  var chain = Promise.resolve();

  function doSync() {
    return getCart().then(function (cart) {
      if (!cart || !Array.isArray(cart.discount_codes)) return; // unknown shape: never touch the customer's codes
      var codes = cart.discount_codes.map(function (c) { return c.code; });
      var has = codes.some(function (c) { return same(c, CODE); });
      var want = hasKnife(cart);
      if (want === has) return;
      if (want) {
        return setCodes(codes.concat([CODE])).then(function (after) {
          // code missing, expired or not valid for this cart: do not leave a dead code showing up at checkout
          var entry = (after.discount_codes || []).filter(function (c) { return same(c.code, CODE); })[0];
          if (entry && entry.applicable === false) return setCodes(codes);
        });
      }
      return setCodes(codes.filter(function (c) { return !same(c, CODE); }));
    });
  }

  function sync() {
    pending++;
    chain = chain.then(doSync).catch(function () {}).then(function () { pending--; });
    return chain;
  }

  window.HmcShip = {
    enabled: !!CODE,
    sync: sync,
    // Used by the cart discount form: returns the discount string to send so the knife code is kept.
    codesFor: function (userCode) {
      if (!CODE) return Promise.resolve(userCode);
      return getCart().then(function (cart) {
        var list = [userCode];
        if (hasKnife(cart) && !same(userCode, CODE)) list.push(CODE);
        return list.join(',');
      }).catch(function () { return userCode; });
    }
  };
  if (!CODE) return;

  // watch every cart mutation (product form, drawer quantity, upsell add, remove, ...) and re-sync afterwards
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var internal = init && init.headers && init.headers['X-HMC-Ship'];
    var p = origFetch.apply(this, arguments);
    if (!internal && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      pending++;
      p.then(function (r) {
        setTimeout(function () { pending--; if (r && r.ok) sync(); }, 60);
      }, function () { pending--; });
    }
    return p;
  };

  // make sure the code state is final before the browser leaves for checkout
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[name="checkout"]');
    if (!b || b.__hmcShipReady || !pending) return;
    e.preventDefault();
    e.stopPropagation();
    var wait = function () {
      if (pending > 0) return chain.then(function () { return new Promise(function (r) { setTimeout(r, 120); }); }).then(wait);
    };
    Promise.resolve(wait()).then(function () { b.__hmcShipReady = true; b.click(); b.__hmcShipReady = false; });
  }, true);

  function start() {
    if (/(^|;\s*)cart=/.test(document.cookie)) sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
})();
